// extracted by mini-css-extract-plugin
module.exports = {"work":"Optimization_index_work__3cLzW","citeI":"Optimization_index_citeI__jwnIE","installImg":"Optimization_index_installImg__2bqo3"};